const isPromise = (value) => value instanceof Promise;

// noinspection JSUnusedGlobalSymbols
export default isPromise;
